// extracted by mini-css-extract-plugin
export var menuIcon = "_jt-0";
export var menuIconInline = "_jt-1";